import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import lang from '../../../lib/language';
import { RootState } from '../../../lib/store';
import { getCurrentBuyingPower } from '../../../lib/store/selectors';
import { calculateCashPortfolioProportion } from '../../../lib/util/my-account-helpers';

import PieChart from '../PieChart/PieChart';

import CashDetails from './CashDetails/CashDetails';

import styles from './CashPortfolioChart.module.scss';

type Props = {
  isSmallScreen?: boolean;
};

const CashPortfolioChart = ({ isSmallScreen }: Props) => {
  const [chartData, setChartData ] = useState<number[]>([]);
  const [portfolioValue, setPortfolioValue] = useState<number>(0);
  const buyingPower = useSelector<RootState, number>((state: RootState) => getCurrentBuyingPower(state));

  useEffect(() => {
    if (buyingPower || portfolioValue) {
      setChartData([buyingPower > 0 ? buyingPower : 0, portfolioValue > 0 ? portfolioValue : 0]);
    }
  }, [buyingPower, portfolioValue]);

  return (
    <div className={styles.wrapper}>
      <svg width="100%" height="186" viewBox="0 0 400 250">
        <PieChart
          chartData={chartData}
          chartValue={calculateCashPortfolioProportion(portfolioValue, buyingPower)}
          labelText={`${lang.mobilePortfolioTitle()} / ${lang.commonAccountBreakdownCashToInvest()}`}
        />
      </svg>
      <CashDetails
        setPortfolioValue={val => setPortfolioValue(val)}
      />
    </div>
  );
};

export default CashPortfolioChart;
